const e = {
  id: "OregonLuckyLines",
  name: "Lucky Lines",
  style: {
    colorPrimary: "#ff6b00"
  }
};
export {
  e as default
};
